/**
 * @function getQueryStringParameter
 * @memberof Promega.Util
 * @description Gets the requested parameter from the query string in the given URL
 * @param {String} url The URL to use
 * @param {String} parameterName The name of the parameter to retrieve
 * @returns {String} The retrieved value, if it exists
 */
export default function getQueryStringParameter(url, parameterName) {
    // eslint-disable-next-line no-useless-escape
    let currentName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]"),
        regexS = "[\\?&]" + currentName + "=([^&#]*)",
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if ( results == null ) {
        return "";
    } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
}
